import { pb } from './pocketbase';
import eventEmitter from './event.service';

export const searchProspectCompanies = async (query) => {
    try {
        if (!query || query.length < 2) {
            return [];
        }

        // Recherche par nom ou SIRET
        const result = await pb.collection('prospects_company').getList(1, 10, {
            filter: `name ~ "${query}" || siret ~ "${query}"`
        });

        return result.items;
    } catch (error) {
        console.error('Erreur lors de la recherche des entreprises prospects:', error);
        return [];
    }
};

export const getProspectCompany = async (options = {}) => {
    try {
        const queryOptions = {
            sort: options.sort || '-created',
            expand: 'assigned_to',
            page: options.page || 1,
            perPage: options.perPage || 20,
            filter: options.filter || null,
            fullData: options.fullData || false
        };
        
        const pbQuery = {
            sort: queryOptions.sort,
            expand: queryOptions.expand
        };

        // Si fullData est false, on limite les champs récupérés pour optimiser
        // Si fullData est true, on récupère tous les champs pour la page de détail
        if (!queryOptions.fullData) {
            pbQuery.fields = options.fields || 'id,name,siret,sector,status,representative_email,representative_phone,representative_lastname,representative_firstname,company_size,expand.assigned_to';
        }

        if (queryOptions.filter) {
            pbQuery.filter = queryOptions.filter;
        }

        const result = await pb.collection('prospects_company').getList(
            queryOptions.page,
            queryOptions.perPage,
            pbQuery
        );
        
        return {
            items: result.items,
            totalItems: result.totalItems,
            totalPages: result.totalPages,
            page: result.page
        };
    } catch (error) {
        console.error('Erreur lors de la récupération des entreprises prospects:', error);
        return {
            items: [],
            totalItems: 0,
            totalPages: 0,
            page: 1
        };
    }
};

export const getProspectCompanyById = async (id) => {
    try {
        const record = await pb.collection('prospects_company').getOne(id, {
            expand: 'assigned_to'
        });
        return record;
    } catch (error) {
        console.error('Erreur lors de la récupération de l\'entreprise prospect:', error);
        throw error;
    }
};

export const createProspectCompany = async (companyData) => {
    try {

        if (!pb.authStore.isValid || !pb.authStore.model) {
            throw new Error('Aucun utilisateur authentifié. Impossible de créer l\'entreprise.');
        }

        if (!pb.authStore.record?.partner_id) {
            throw new Error('Partner ID manquant dans l\'utilisateur connecté.');
        }

        // Ajouter le partner_id de l'utilisateur connecté
        const companyWithPartnerId = {
            ...companyData,
            partner_id: pb.authStore.record.partner_id
        };


        const createdCompany = await pb.collection('prospects_company').create(companyWithPartnerId);


        // Déclencher l'événement pour mettre à jour le compteur
        eventEmitter.dispatch('prospectCompaniesUpdated');

        return createdCompany;
            
    } catch (error) {
        throw error;
    }
};

export const createProspectCompanyAdmin = async (companyData) => {
    try {

        if (!pb.authStore.isValid || !pb.authStore.model) {
            throw new Error('Aucun utilisateur authentifié. Impossible de créer l\'entreprise.');
        }

        if (!pb.authStore.record?.partner_id) {
            throw new Error('Partner ID manquant dans l\'utilisateur connecté.');
        }

        // Ajouter le partner_id de l'utilisateur connecté
        const companyWithPartnerId = {
            ...companyData,
            partner_id: pb.authStore.record.partner_id,
            status: 'Nouveau'
        };

        const createdCompany = await pb.collection('prospects_company').create(companyWithPartnerId);

        // Déclencher l'événement pour mettre à jour le compteur
        eventEmitter.dispatch('prospectCompaniesUpdated');

        return createdCompany;
    } catch (error) {
        throw error;
    }
};

export const getProspectCompanies = async (partnerId) => {
    try {
        const records = await pb.collection('prospects_company').getList(1, 50, {
            filter: `partner_id="${partnerId}"`,
            sort: '-created'
        });
        return records.items;
    } catch (error) {
        if (error.status === 404) {
            return [];
        }
        throw error;
    }
};

export const updateProspectCompany = async (companyId, updateData) => {
    try {
        const updatedCompany = await pb.collection('prospects_company').update(companyId, updateData);
        
        // Déclencher l'événement pour mettre à jour le compteur si le statut change
        if (updateData.status) {
            eventEmitter.dispatch('prospectCompaniesUpdated');
        }
        
        return updatedCompany;
    } catch (error) {
        throw error;
    }
};

export const deleteProspectCompany = async (companyId) => {
    try {
        await pb.collection('prospects_company').delete(companyId);
        
        // Déclencher l'événement pour mettre à jour le compteur
        eventEmitter.dispatch('prospectCompaniesUpdated');
        
        return true;
    } catch (error) {
        throw error;
    }
};

export const assignCommercialToProspectCompany = async (prospectCompanyId, commercialId) => {
    try {
        const record = await pb.collection('prospects_company').update(prospectCompanyId, { 
            assigned_to: commercialId 
        });
        
        // Déclencher l'événement pour mettre à jour le compteur
        eventEmitter.dispatch('prospectCompaniesUpdated');
        
        return record;
    } catch (error) {
        console.error('Erreur lors de l\'assignation du commercial au prospect entreprise:', error);
        throw error;
    }
};

export const getUnassignedProspectCompaniesCount = async () => {
    try {
        const records = await pb.collection('prospects_company').getFullList({
            filter: 'assigned_to = null',
        });
        return records.length;
    } catch (error) {
        return 0;
    }
};